// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"54":"855a3eda","135":"bb3b3ff9","453":"0b35aea5","687":"b2bce9b4","825":"0490f910","857":"2f876628","889":"20ca6553","901":"8f261128"}[chunkId] + ".chunk.css";
};